

























































import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { SaveLiteratureData } from "@/api/pdOutPatient/pdMedicalLiterature";
@Component({})
export default class extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Object, default: {} }) data: any;
  form: any = {};
  Url = XMLHTTP_BASEURL;
  imageUrlList: any = [];
  pdfList: any = [];
  created() {
    this.form = Object.assign({}, this.data);
    if (this.form.pdfList) {
      this.pdfList = this.form.pdfList;
    }
  }
  rules = {};
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async save() {
    this.form.pdfList = this.pdfList;
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        let res = await SaveLiteratureData(this.form);
        if (res.status == 1) {
          this.$emit("input", false);
          this.$emit("on-success");
        }
      }
    });
  }
  handleSignSuccess1(res: any, file: any) {
    let url = res.result.objects.imageAddress;
    let name = res.result.objects.fileName;
    this.pdfList.push({ fileName: name, fileUrl: url });
  }
  get headers() {
    return {
      "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie(),
      Authorization: "Bearer " + window.abp.auth.getToken()
    };
  }
  handleRemovePdf(file: any) {
    this.pdfList.splice(
      this.pdfList.findIndex((x: any) => x.fileUrl == file.fileUrl),
      1
    );
  }
  handleFormatError1(file: any) {
    this.$Message.warning("请选择'pdf'格式文件！");
  }
  handleMaxSize1(file: any) {
    this.$Message.warning("请选择小于200M文件！");
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdMedicalLiterature/addMedicalLiterature.vue